import axios from './request'

//登录
export const login = (data) => {
    return axios.post('/System/Login', data)
}

//登出
export const loginOut = (data) => {
    return axios.post('/System/OutLogin', data)
}

//获取刷新token
export const getRefreshToken = (data) => {
    return axios.post('/System/GetAccessToken', data)
}

//获取自己的密码
export const GetSlefPassword = (data) => {
    return axios.post('/System/GetPassword', data)
}

//修改自己的密码
export const ChangePassword = (data) => {
    return axios.post('/System/ChangePassword', data)
}

//获取菜单
export const GetMenuList = (data) => {
    return axios.post('/System/GetMenuList', data)
}

//获取厂商列表
export const GroupList = (data) => {
    return axios.post('/SystemManage/GroupList', data)
}

//新增厂商
export const CreateGroup = (data) => {
    return axios.post('/SystemManage/CreateGroup', data)
}

//编辑厂商
export const UpdateGroup = (data) => {
    return axios.post('/SystemManage/UpdateGroup', data)
}

//获取厂商角色
export const RoleList = (data) => {
    return axios.post('/SystemManage/RoleList', data)
}

//获取所有功能模块
export const GetAllModuleList = (data) => {
    return axios.post('/System/GetAllModuleList', data)
}

//获取角色功能模块
export const RoleModuleIds = (data) => {
    return axios.post('/SystemManage/RoleModuleIds', data)
}

//新增厂商角色
export const AddRole = (data) => {
    return axios.post('/SystemManage/AddRole', data)
}

//编辑厂商角色
export const UpdateRole = (data) => {
    return axios.post('/SystemManage/UpdateRole', data)
}

//编辑厂商角色
export const AddRoleModules = (data) => {
    return axios.post('/SystemManage/AddRoleModules', data)
}

//获取用户列表
export const UserList = (data) => {
    return axios.post('/SystemManage/UserList', data)
}

//新增用户
export const AddUser = (data) => {
    return axios.post('/SystemManage/AddUser', data)
}

//编辑用户信息
export const UpdateUser = (data) => {
    return axios.post('/SystemManage/UpdateUser', data)
}

//删除用户
export const DeleteUser = (data) => {
    return axios.post('/SystemManage/DeleteUser', data)
}

//重置用户密码
export const RestUser = (data) => {
    return axios.post('/SystemManage/RestUser', data)
}

//用户获取厂商所有角色
export const GroupAllRoleList = (data) => {
    return axios.post('/SystemManage/GroupAllRoleList', data)
}

//获取网点列表
export const PersonNodeList = (data) => {
    return axios.post('/Service/PersonNodeList', data)
}

//获取客户列表
export const CustomerList = (data) => {
    return axios.post('/Info/CustomerList', data)
}

//添加客户
export const AddCustomer = (data) => {
    return axios.post('/Info/AddCustomer', data)
}

//更新客户信息
export const UpdateCustomer = (data) => {
    return axios.post('/Info/UpdateCustomer', data)
}

//获取地区树
export const GetAreaTree = (data) => {
    return axios.post('/System/GetAreaTree', data)
}

//获取产品型号列表
export const JModelList = (data) => {
    return axios.post('/Info/JModelList', data)
}

//新增产品型号
export const AddJModel = (data) => {
    return axios.post('/Info/AddJModel', data)
}

//编辑产品型号
export const UpdateJModel = (data) => {
    return axios.post('/Info/UpdateJModel', data)
}

//获取销售公司列表
export const SalesCompanyList = (data) => {
    return axios.post('/Info/SalesCompanyList', data)
}

//新增销售公司
export const AddSalesCompany = (data) => {
    return axios.post('/Info/AddSalesCompany', data)
}

//编辑销售公司
export const UpdateSalesCompany = (data) => {
    return axios.post('/Info/UpdateSalesCompany', data)
}

//获取服务人员列表
export const ServeCustomerList = (data) => {
    return axios.post('/Service/CustomerList', data)
}

//添加服务人员
export const ServeAddCustomer = (data) => {
    return axios.post('/Service/AddCustomer', data)
}

//删除服务人员
export const DelCustomer = (data) => {
    return axios.post('/Service/DelCustomer', data)
}

//编辑服务人员
export const ServeUpdateCustomer = (data) => {
    return axios.post('/Service/UpdateCustomer', data)
}

//获取网点列表
export const NodeList = (data) => {
    return axios.post('/Service/NodeList', data)
}

//新增网点
export const AddNode = (data) => {
    return axios.post('/Service/AddNode', data)
}

//更新网点
export const UpdateNode = (data) => {
    return axios.post('/Service/UpdateNode', data)
}

//获取报修记录列表
export const RepairList = (data) => {
    return axios.post('/Service/RepairList', data)
}

//添加报修记录
export const AddRepair = (data) => {
    return axios.post('/Service/AddRepair', data)
}

//编辑报修记录
export const UpdateRepair = (data) => {
    return axios.post('/Service/UpdateRepair', data)
}

//根据网点查询网点人员
export const TheNodeCustomerList = (data) => {
    return axios.post('/Service/TheNodeCustomerList', data)
}

//获取监控主机列表
export const DeviceList = (data) => {
    return axios.post('/Machine/DeviceList', data)
}

//获取未使用监控主机
export const UnUseDeviceList = (data) => {
    return axios.post('/Machine/UnUseDeviceList', data)
}

//添加监控主机
export const AddDevice = (data) => {
    return axios.post('/Machine/AddDevice', data)
}

//编辑监控主机
export const UpdateDevice = (data) => {
    return axios.post('/Machine/UpdateDevice', data)
}

//获取视频列表
export const VideoList = (data) => {
    return axios.post('/Machine/VideoList', data)
}

//获取未使用视频列表
export const UnUseVideoList = (data) => {
    return axios.post('/Machine/UnUseVideoList', data)
}

//添加视频
export const AddVideo = (data) => {
    return axios.post('/Machine/AddVideo', data)
}

//更新视频信息
export const UpdateVideo = (data) => {
    return axios.post('/Machine/UpdateVideo', data)
}

//获取设备列表
export const MachineList = (data) => {
    return axios.post('/Machine/MachineList', data)
}

//添加设备
export const AddMachine = (data) => {
    return axios.post('/Machine/AddMachine', data)
}

//编辑设备
export const UpdateMachine = (data) => {
    return axios.post('/Machine/UpdateMachine', data)
}

//设备转正式
export const MachineToOk = (data) => {
    return axios.post('/Machine/MachineToOk', data)
}

//查询还款记录
export const PaymentList = (data) => {
    return axios.post('/Loan/PaymentList', data)
}

//还款
export const Repayment = (data) => {
    return axios.post('/Loan/Repayment', data)
}

//还款记录
export const LoanList = (data) => {
    return axios.post('/Loan/LoanList', data)
}

//以下是大屏接口----------------------------------------------------------

//生产情况信息
export const ProductionInfo = (data) => {
    return axios.post('/BigScreen/ProductionInfo', data)
}

//收款情况信息
export const CollectionInfo = (data) => {
    return axios.post('/BigScreen/CollectionInfo', data)
}

//销售情况信息
export const SaleInfo = (data) => {
    return axios.post('/BigScreen/SaleInfo', data)
}

//服务情况信息
export const ServiceInfo = (data) => {
    return axios.post('/BigScreen/ServiceInfo', data)
}

//告警情况信息
export const AbnormalInfo = (data) => {
    return axios.post('/BigScreen/AbnormalInfo', data)
}

//关注设备
export const AttentionDeviceInfo = (data) => {
    return axios.post('/BigScreen/AttentionDeviceInfo', data)
}

//产品版图
export const DeviceAddressInfo = (data) => {
    return axios.post('/BigScreen/DeviceAddressInfo', data)
}

//客户分布
export const CustomerAddressInfo = (data) => {
    return axios.post('/BigScreen/CustomerAddressInfo', data)
}

//服务网点
export const NodeAddressInfo = (data) => {
    return axios.post('/BigScreen/NodeAddressInfo', data)
}

//生产页设备产量信息
export const DeviceYieldInfo = (data) => {
    return axios.post('/BigScreen/DeviceYieldInfo', data)
}

//生产页规格型号排行
export const ModelRankingInfo = (data) => {
    return axios.post('/BigScreen/ModelRankingInfo', data)
}

//生产页年度发货排行
export const DeliverGoodsInfo = (data) => {
    return axios.post('/BigScreen/DeliverGoodsInfo', data)
}

//生产也中国地图数据
export const DeviceMapTotalInfo = (data) => {
    return axios.post('/BigScreen/DeviceMapTotalInfo', data)
}

//生产页表格数据
export const DeviceDataListInfo = (data) => {
    return axios.post('/BigScreen/DeviceDataListInfo', data)
}

//客户性质信息
export const CustomerNatureInfo = (data) => {
    return axios.post('/BigScreen/CustomerNatureInfo', data)
}

//公司总信息
export const CompanyYearSaleInfo = (data) => {
    return axios.post('/BigScreen/CompanyYearSaleInfo', data)
}

//省区客户量信息
export const ProvinceCustomerVolumeInfo = (data) => {
    return axios.post('/BigScreen/ProvinceCustomerVolumeInfo', data)
}

//客户购买实力排行
export const CustomerPurchasingPowerInfo = (data) => {
    return axios.post('/BigScreen/CustomerPurchasingPowerInfo', data)
}

//全国销量热力图
export const SalesHeatChartInfo = (data) => {
    return axios.post('/BigScreen/SalesHeatChartInfo', data)
}

//收款饼图信息
export const LoanPieChartInfo = (data) => {
    return axios.post('/BigScreen/LoanPieChartInfo', data)
}

//超期公司信息
export const LoanCompanyInfo = (data) => {
    return axios.post('/BigScreen/LoanCompanyInfo', data)
}

//设备收款信息
export const LoanDataListInfo = (data) => {
    return axios.post('/BigScreen/LoanDataListInfo', data)
}

//服务饼图信息
export const NodePieChartInfo = (data) => {
    return axios.post('/BigScreen/NodePieChartInfo', data)
}

//服务模块地图
export const RepairMapInfo = (data) => {
    return axios.post('/BigScreen/RepairMapInfo', data)
}

//服务模块表格
export const RepairLogInfo = (data) => {
    return axios.post('/BigScreen/RepairLogInfo', data)
}

//公司基本信息
export const EnterpriseBasicInfo = (data) => {
    return axios.post('/BigScreen/EnterpriseBasicInfo', data)
}

//公司购买信息柱图
export const EnterprisePurchaseInfo = (data) => {
    return axios.post('/BigScreen/EnterprisePurchaseInfo', data)
}

//公司页面地图
export const MachineDistributionInfo = (data) => {
    return axios.post('/BigScreen/MachineDistributionInfo', data)
}

//公司页面表格
export const ContractDataInfo = (data) => {
    return axios.post('/BigScreen/ContractDataInfo', data)
}

//异常页面数据
export const MonthStatisticInfo = (data) => {
    return axios.post('/BigScreen/MonthStatisticInfo', data)
}

//异常页面设备数量
export const DeviceStatisticInfo = (data) => {
    return axios.post('/BigScreen/DeviceStatisticInfo', data)
}

//设备基础信息
export const DeviceBasicsInfo = (data) => {
    return axios.post('/BigScreen/DeviceBasicsInfo', data)
}

//设备实况状态
export const DeviceRealtimeInfo = (data) => {
    return axios.post('/BigScreen/DeviceRealtimeInfo', data)
}

//设备表盘信息
export const DeviceChartListInfo = (data) => {
    return axios.post('/BigScreen/DeviceChartListInfo', data)
}

//设备异常信息
export const DeviceAbnormalInfo = (data) => {
    return axios.post('/BigScreen/DeviceAbnormalInfo', data)
}

//设备视频
export const DeviceVideoInfo = (data) => {
    return axios.post('/BigScreen/DeviceVideoInfo', data)
}

//关注设备
export const FocusImei = (data) => {
    return axios.post('/BigScreen/FocusImei', data)
}

//获取锁机记录
export const LockLogList = (data) => {
    return axios.post('/Machine/LockLogList', data)
}

//锁机、解锁
export const DeviceLock = (data) => {
    return axios.post('/BigScreen/DeviceLock', data)
}

//获取15天最后打卡人
export const DeviceLastPerson = (data) => {
    return axios.post('/BigScreen/DeviceLastPerson', data)
}

//获取服役统计
export const DeliverWorkInfo = (data) => {
    return axios.post('/BigScreen/DeliverWorkInfo', data)
}

//设备锁机历史记录
export const DeviceLockHistory = (data) => {
    return axios.post('/BigScreen/DeviceLockHistory', data)
}

//设备锁机分页历史记录
export const DeviceLockHistoryPage = (data) => {
    return axios.post('/BigScreen/DeviceLockHistoryPage', data)
}

//设备15天打卡记录
export const Device15DayPerson = (data) => {
    return axios.post('/BigScreen/Device15DayPerson', data)
}

//塔机变频数据
export const TowerFrequencytory = (data) => {
    return axios.post('/BigScreen/TowerFrequencytory', data)
}